import {
  Component,
  DestroyRef,
  ElementRef,
  HostBinding,
  inject,
  Input,
  OnInit
} from '@angular/core';
import { VexLayoutService } from 'src/@vex/services/vex-layout.service';
import { VexConfigService } from 'src/@vex/config/vex-config.service';
import { filter, map, startWith, switchMap } from 'rxjs/operators';
import { NavigationService } from '../../../core/navigation/navigation.service';
import { VexPopoverService } from 'src/@vex/components/vex-popover/vex-popover.service';
import { MegaMenuComponent } from './mega-menu/mega-menu.component';
import { Observable, of } from 'rxjs';
import { NavigationComponent } from '../navigation/navigation.component';
import { ToolbarUserComponent } from './toolbar-user/toolbar-user.component';
import { ToolbarNotificationsComponent } from './toolbar-notifications/toolbar-notifications.component';
import { NavigationItemComponent } from '../navigation/navigation-item/navigation-item.component';
import { MatMenuModule } from '@angular/material/menu';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NavigationItem } from '../../../core/navigation/navigation-item.interface';
import { checkRouterChildsData } from 'src/@vex/utils/check-router-childs-data';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment.prod';
import { AuthService } from 'src/app/shared/services/auth.service';
import { User } from 'src/core/interfaces/user';
import { Permissions } from 'src/assets/static-data/permissions';
import { UserService } from 'src/app/shared/services/user.service';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationService } from 'src/app/shared/services/notification.service';

@Component({
  selector: 'vex-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    NgIf,
    RouterLink,
    MatMenuModule,
    NgClass,
    NgFor,
    NavigationItemComponent,
    ToolbarNotificationsComponent,
    ToolbarUserComponent,
    NavigationComponent,
    AsyncPipe,
    TranslateModule,
  ]
})
export class ToolbarComponent implements OnInit {
  @HostBinding('class.shadow-b')
  showShadow: boolean = false;
  permissions= new  Permissions();
  isDriverRole:boolean=false;
  isSalesAgentRole:boolean=false;

  navigationItems$: Observable<NavigationItem[]> =
    this.navigationService.items$;

  isHorizontalLayout$: Observable<boolean> = this.configService.config$.pipe(
    map((config) => config.layout === 'horizontal')
  );
  isVerticalLayout$: Observable<boolean> = this.configService.config$.pipe(
    map((config) => config.layout === 'vertical')
  );
  isNavbarInToolbar$: Observable<boolean> = this.configService.config$.pipe(
    map((config) => config.navbar.position === 'in-toolbar')
  );
  isNavbarBelowToolbar$: Observable<boolean> = this.configService.config$.pipe(
    map((config) => config.navbar.position === 'below-toolbar')
  );
  userVisible$: Observable<boolean> = this.configService.config$.pipe(
    map((config) => config.toolbar.user.visible)
  );
  title$: Observable<string> = this.configService.select(
    (config) => config.sidenav.title
  );

  isDesktop$: Observable<boolean> = this.layoutService.isDesktop$;
  megaMenuOpen$: Observable<boolean> = of(false);
  private readonly destroyRef: DestroyRef = inject(DestroyRef);
  flagImg:string=localStorage.getItem('lang')=='en'?'flag:united-states': localStorage.getItem('lang')=='ur'? 'flag:pakistan' : 'flag:saudi-arabia';
  portalType:string=environment.portalType;
  currentUser: User;

  private _client : any;
  private _baseUrl = `${environment.apiURL}/api`
  @Input() mobileQuery: boolean;
  isDriver : boolean;
  pageIndex: number = 0;
  isMobile: boolean;

  @Input()
  @HostBinding('class.shadow-b')
  hasShadow: boolean;
  navigationItems = this.navigationService.items$;


  notificationCount$: Observable<number>;
  flags = {
    "en": "assets/img/demo/en.png",
    "ar": "assets/img/demo/ar.png"
  };
  imgSrc : string;
  notificationTotalCount$: Observable<number>;
  currentUserId: string;
  constructor(
    private readonly layoutService: VexLayoutService,
    private readonly configService: VexConfigService,
    private readonly navigationService: NavigationService,
    private readonly popoverService: VexPopoverService,
    private readonly router: Router,
    private readonly translateService: TranslateService,
    private readonly userService:UserService,
    private authService: AuthService,
              private notificationService: NotificationService,
              private snackBar: MatSnackBar, 
  ) {   }

  ngOnInit() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        startWith(null),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.showShadow = checkRouterChildsData(
          this.router.routerState.root.snapshot,
          (data) => data.toolbarShadowEnabled ?? false
        );
      });
      this.isDriverRole=this.authService.isDriverUserValue;
      this.isSalesAgentRole=this.authService.isSalesAgentValue;
      this.currentUser = this.authService.currentUserValue;


    //   this._client = new HubConnectionBuilder()
    //   .withUrl(`${this._baseUrl}/notification/signalr`, {
    //     accessTokenFactory: () => this.authService.currentUserValue.token,
    //   })
    //   .build();
    // this.notificationCount$ = this.notificationService.notificationCount$;
    // this.notificationTotalCount$ = this.notificationService.notificationTotalCount;

    // this._client.on("SendNotification", (notification,usersIds) => {
    //   // // debugger;
    //   this.currentUserId = this.authService.currentUserValue.id;
    //   if(usersIds.includes(this.authService.currentUserValue.id)){
    //     // // debugger;
    //     this.notificationService.getUserNotifications(this.currentUserId).subscribe(_ => {
    //       this.notificationCount$ = this.notificationService.notificationCount$;
    //       this.notificationTotalCount$ = this.notificationService.notificationTotalCount;
    //       console.log(this.notificationTotalCount$);
    //     });
    //     this.snackBar.open(this.translateService.instant("NEW_NOTIFICATION_ARRIVED.TEXT"), this.translateService.instant("CLOSE.TEXT"), {
    //       duration: 5000
    //     });
    //   }
    //   this.notificationService.getUserNotifications(this.currentUserId).subscribe((response: any) => {
    //     console.log(response);
    //     this.notificationCount$ = response.data.length;
    //     this.snackBar.open('New Notification arrived', 'close', {
    //       duration: 5000
    //     });
    //   });
    // })
  }

  openQuickpanel(): void {
    this.layoutService.openQuickpanel();
  }

  openSidenav(): void {
    this.layoutService.openSidenav();
  }

  openMegaMenu(origin: ElementRef | HTMLElement): void {
    this.megaMenuOpen$ = of(
      this.popoverService.open({
        content: MegaMenuComponent,
        origin,
        offsetY: 12,
        position: [
          {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top'
          },
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top'
          }
        ]
      })
    ).pipe(
      switchMap((popoverRef) => popoverRef.afterClosed$.pipe(map(() => false))),
      startWith(true)
    );
  }

  openSearch(): void {
    this.layoutService.openSearch();
  }

  changeLang(lang:string,flagImg:string):void{
    // debugger
    this.userService.updateUserLanguage(this.currentUser.id,lang).subscribe(res=>{
      this.configService.updateConfig({
        direction: (lang==='ar' || lang==='ur') ? 'rtl' : 'ltr'
      });
  
      this.flagImg=flagImg;
      this.translateService.use(lang);
      localStorage.setItem('lang', lang); // Store the selected language
      document.body.dir =  (lang=='ar' || lang=='ur') ?'rtl':'ltr';
      location.reload();
    });
  }

  clearLocalStorage() {
    //localStorage.clear();
    location.reload();
  }

}
